import React from 'react';
import { EmpowerPayrollExportForm } from './EmpowerPayrollExportForm';
import { EmpowerImportForm } from './EmpowerImportForm';
import { MepExportForm, PcsExportForm } from './MepExportForm';
import { MepImportForm, PcsImportForm } from './MepImportForm';
import { MepExportDemographicsForm, PcsExportDemographicsForm } from './MepExportDemographicsForm';
import { SeedTalentCourseCompletionForm } from './SeedTalentCourseCompletionForm';
import { DayforceEmployeeImportForm, validateDayforceEmployeeImport } from './DayforceEmployeeImportForm';
import { SftpFileFeedForm } from './SftpFileFeedForm';
import { validateSftpFeed } from './sftpFileFeedConfig';
import { LrsImportForm } from './LrsImportForm';
import { LrsPayrollExportForm } from './LrsPayrollExportForm';
import { validateLrsImport, validateLrsPayrollExport } from './lrsConfig';

export const jobTypeInfo = {
  '': {
    form: () => <></>
  },
  'empower-payroll-export': {
    form: EmpowerPayrollExportForm,
    label: "Empower 401(k) payroll export",
    extraInfo: <>Infrastructure (SFTP credentials, PGP key, file naming) is pre-configured for Empower. You only need to fill the fields below</>
  },
  'empower-import': {
    form: EmpowerImportForm,
    label: "Empower 401(k) import",
    extraInfo: <>Infrastructure (SFTP credentials, PGP key, file naming) is pre-configured for Empower. You only need to fill the fields below</>
  },
  'lrs-payroll-export': {
    form: LrsPayrollExportForm,
    label: "LRS 401(k) payroll export",
    extraInfo: <>Builds the LRS payroll files from the client's Retirement and Workers Comp reports. Enter the client's SFTP and Kronos credentials here.</>,
    validate: validateLrsPayrollExport
  },
  'lrs-import': {
    form: LrsImportForm,
    label: "LRS 401(k) deferral change import",
    extraInfo: <>Imports LRS deferral change files into Wurk. Enter the client's SFTP and Kronos credentials here.</>,
    validate: validateLrsImport
  },
  'mep-export': {
    form: MepExportForm,
    label: "MEP 401(k) export",
    extraInfo: <>Infrastructure (SFTP credentials, Kronos API user) is pre-configured for MEP. You only need to fill the fields below</>
  },
  'pcs-export': {
    form: PcsExportForm,
    label: "PCS 401(k) export",
    extraInfo: <>Infrastructure (SFTP credentials, Kronos API user) is pre-configured for PCS. You only need to fill the fields below</>
  },
  'mep-import': {
    form: MepImportForm,
    label: "MEP 401(k) import",
    extraInfo: <>Infrastructure (SFTP credentials, Kronos API user) is pre-configured for MEP. You only need to fill the fields below</>
  },
  'pcs-import': {
    form: PcsImportForm,
    label: "PCS 401(k) import",
    extraInfo: <>Infrastructure (SFTP credentials, Kronos API user) is pre-configured for PCS. You only need to fill the fields below</>
  },
  'mep-exportDemographics': {
    form: MepExportDemographicsForm,
    label: "MEP 401(k) demographics export",
    extraInfo: <>Infrastructure (SFTP credentials, Kronos API user) is pre-configured for MEP. You only need to fill the fields below</>
  },
  'pcs-exportDemographics': {
    form: PcsExportDemographicsForm,
    label: "PCS 401(k) demographics export",
    extraInfo: <>Infrastructure (SFTP credentials, Kronos API user) is pre-configured for PCS. You only need to fill the fields below</>
  },
  'seed-talent-course-completion': {
    form: SeedTalentCourseCompletionForm,
    label: "Seed Talent course integration",
    extraInfo: <>Syncs Seed Talent courses into Wurk and writes completions back. The client provides the Seed Talent API credentials</>
  },
  'dayforce-employee-import': {
    form: DayforceEmployeeImportForm,
    label: 'Dayforce employee import',
    extraInfo: <>Imports Dayforce employee records into Wurk. You provide the SFTP credentials and the PGP private key</>,
    validate: validateDayforceEmployeeImport,
  },
  'generic-import': {
    form: SftpFileFeedForm,
    label: 'SFTP file import',
    extraInfo: <>Inbound vendor file. Enter the SFTP connection, folder, and schedule here. Credentials are encrypted on save and are not shown again.</>,
    validate: validateSftpFeed
  },
  'generic-export': {
    form: SftpFileFeedForm,
    label: 'SFTP file export',
    extraInfo: <>Outbound file to a vendor. Enter the SFTP connection, file name, and schedule here. Credentials are encrypted on save and are not shown again.</>,
    validate: validateSftpFeed
  }
}
